import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ConstantService {

	constructor() { }


	refSrcImages: any[] = [
		{ label: 'VRBO', value: 1, ruChannelId: 420853, imgurl: 'assets/img/channel/vrbo.png' }, 
		{ label: 'Google', value: 7, ruChannelId: 554691, imgurl: 'assets/img/channel/google.png' },
		{ label: 'Expedia', value: 12, ruChannelId: 421402, imgurl: 'assets/img/channel/expedia.png' },
		{ label: 'Booking.com', value: 13, ruChannelId: 421327, imgurl: 'assets/img/channel/booking.png' },
		{ label: 'AirBnb', value: 14, ruChannelId: 426592, imgurl: 'assets/img/channel/airbnb.png' },
		{ label: 'Marriott', value: 15, ruChannelId: 568092, imgurl: 'assets/img/channel/marriott.png' },
		{ label: 'TripAdvisor', value: 16, ruChannelId: 527559, imgurl: 'assets/img/channel/tripadvisor.png' },
		{ label: 'GolfHom', value: 17, ruChannelId: 567882, imgurl: 'assets/img/channel/golfhom.png' },
		{ label: 'Friends and Family', value: 10, ruChannelId: 111119, imgurl: 'assets/img/header-logo.png' },
		{ label: 'Website', value: 11, ruChannelId: 111110, imgurl: 'assets/img/header-logo.png' },
		{ label: 'Unknown', value: 8, ruChannelId: 111117, imgurl: 'assets/img/header-logo.png' },
		{ label: 'Homeowner', value: 9, ruChannelId: 111118, imgurl: 'assets/img/header-logo.png' },
		{ label: 'FlipKey', value: 2, ruChannelId: 527559, imgurl: 'assets/img/header-logo.png' },
		{ label: 'HomeAway', value: 3, ruChannelId: 420853, imgurl: 'assets/img/channel/homeaway.png' },
		{ label: 'CraigsList', value: 4, ruChannelId: 111114, imgurl: 'assets/img/header-logo.png' },
		{ label: 'Guest Referral', value: 5, ruChannelId: 111115, imgurl: 'assets/img/header-logo.png' },
		{ label: 'Repeat Guest', value: 6, ruChannelId: 111116, imgurl: 'assets/img/header-logo.png' },
		{ label: 'Whimstay', value: 19, ruChannelId: 566944, imgurl: 'assets/img/whimstay.png' },  // added by JPM 10-7-2024
		{ label: 'Hopper', value: 20, ruChannelId: 575377, imgurl: 'assets/img/hopper.jpg' },  // added by JPM 10-7-2024
		{ label: 'PlumbGuide', value: 21, ruChannelId: 563746, imgurl: 'assets/img/plumbguide.jpg' }  // added by JPM 10-7-2024
	];

	locations: any[] = [
		{ name: 'Maui', locationId: 1, value: 1, type: 'isl', color: 'green' },
		{ name: 'Park City', locationId: 2, value: 2, type: 'cit', color: 'blue' },
		{ name: 'Big Island', locationId: 3, value: 3, type: 'isl', color: 'lightyellow' },
		{ name: 'Oahu', locationId: 4, value: 4, type: 'isl', color: 'lightyellow' },
		{ name: 'San Diego', locationId: 5, value: 5, type: 'cit', color: 'lightyellow' },
		{ name: 'Aspen', locationId: 6, value: 6, type: 'cit', color: 'lightyellow' },
		{ name: 'Vail', locationId: 7, value: 7, type: 'isl', color: 'lightyellow' },
		{ name: 'Sun Valley', locationId: 8, value: 8, type: 'isl', color: 'lightyellow' },
		{ name: 'Bass Lake', locationId: 9, value: 9, type: 'reg', color: 'F7CEE2' },
		{ name: 'Yosemite', locationId: 10, value: 10, type: 'reg', color: 'CCCAF0' },
		{ name: 'Kauai', locationId: 11, value: 11, type: 'reg', color: 'CCCAF0' },
		{ name: 'East Bay Area (San Francisco)', locationId: 12, value: 12, type: 'reg', color: 'CCCAF0' },
		{ name: 'North Bay Area (San Francisco)', locationId: 13, value: 13, type: 'reg', color: 'CCCAF0' },
		{ name: 'South Bay Area (San Francisco)', locationId: 14, value: 14, type: 'reg', color: 'CCCAF0' },
		{ name: 'Penninsula Bay Area (San Francisco)', locationId: 15, value: 15, type: 'reg', color: 'CCCAF0' },
	];

	RATE_BUCKET = "RateBucket";
	RATE_SEASON = "RateSeason";
	PROPERTY = "Property";
	
	// For find location based on location Id we can use below code
		//this.constantService.locations.find(function(item) { return item.locationId === locationId })?.color;
		//this.constantService.locations.find(function(item) { return item.locationId === locationId })?.name;
	
	// For compare location ids
	 	//if(constantService.locations.locationId === locationId){}
	
	reservationStatuses: any[] = [
		{ label: 'Open', value: 'QO', color: 'lightgreen' },
		{ label: 'Hold', value: 'QH', color: 'yellow' },
		{ label: 'Expired', value: 'QE', color: 'purple' },
		{ label: 'Reserved', value: 'OP', color: 'lightgrey' },
		{ label: 'Closed', value: 'OC', color: 'green' },
		{ label: 'Postponed', value: 'PP', color: 'lightblue' },
		{ label: 'Canceled', value: 'OX', color: 'darkred' },
		{ label: 'Maintenance', value: 'NA', color: 'darkgrey' },
		{ label: 'Owner Occ', value: 'OO', color: 'hotpink' },
		{ label: 'Owner Guest', value: 'OG', color: 'lightpink' }
	];

	resMasterReportType: any[] = [
		{ label: 'By Reservation', value: 1 },
		{ label: 'By Day', value: 2 },
		{ label: 'By Month', value: 3 },
		{ label: 'By Year', value: 4 },
	];

	reservationWikiStatuses: any[] = [
		{ label: 'Open', value: 'O', type: 'G', color: 'lightgreen' },
		{ label: 'Hold', value: 'H', type: 'G', color: 'yellow' },
		{ label: 'Expired', value: 'E', type: 'G', color: 'purple' },
		{ label: 'Confirmed', value: 'C', type: 'G', color: 'lightgrey' },
		{ label: 'Canceled', value: 'X', type: 'G', color: 'darkred' },
		{ label: 'Postponed', value: 'P', type: 'G', color: 'lightblue' },
		{ label: 'Maintenance', value: 'C', type: 'M', color: 'darkgrey' },
		{ label: 'Owner Occ', value: 'C', type: 'O', color: 'hotpink' },
		{ label: 'Owner Guest', value: 'C', type: 'OG', color: 'lightpink' }
	];


	states: any = [
		{
			'name': 'Alabama',
			'abbr': 'AL'
		},
		{
			'name': 'Alaska',
			'abbr': 'AK'
		},
		{
			'name': 'American Samoa',
			'abbr': 'AS'
		},
		{
			'name': 'Arizona',
			'abbr': 'AZ'
		},
		{
			'name': 'Arkansas',
			'abbr': 'AR'
		},
		{
			'name': 'California',
			'abbr': 'CA'
		},
		{
			'name': 'Colorado',
			'abbr': 'CO'
		},
		{
			'name': 'Connecticut',
			'abbr': 'CT'
		},
		{
			'name': 'Delaware',
			'abbr': 'DE'
		},
		{
			'name': 'District Of Columbia',
			'abbr': 'DC'
		},
		{
			'name': 'Federated States Of Micronesia',
			'abbr': 'FM'
		},
		{
			'name': 'Florida',
			'abbr': 'FL'
		},
		{
			'name': 'Georgia',
			'abbr': 'GA'
		},
		{
			'name': 'Guam',
			'abbr': 'GU'
		},
		{
			'name': 'Hawaii',
			'abbr': 'HI'
		},
		{
			'name': 'Idaho',
			'abbr': 'ID'
		},
		{
			'name': 'Illinois',
			'abbr': 'IL'
		},
		{
			'name': 'Indiana',
			'abbr': 'IN'
		},
		{
			'name': 'Iowa',
			'abbr': 'IA'
		},
		{
			'name': 'Kansas',
			'abbr': 'KS'
		},
		{
			'name': 'Kentucky',
			'abbr': 'KY'
		},
		{
			'name': 'Louisiana',
			'abbr': 'LA'
		},
		{
			'name': 'Maine',
			'abbr': 'ME'
		},
		{
			'name': 'Marshall Islands',
			'abbr': 'MH'
		},
		{
			'name': 'Maryland',
			'abbr': 'MD'
		},
		{
			'name': 'Massachusetts',
			'abbr': 'MA'
		},
		{
			'name': 'Michigan',
			'abbr': 'MI'
		},
		{
			'name': 'Minnesota',
			'abbr': 'MN'
		},
		{
			'name': 'Mississippi',
			'abbr': 'MS'
		},
		{
			'name': 'Missouri',
			'abbr': 'MO'
		},
		{
			'name': 'Montana',
			'abbr': 'MT'
		},
		{
			'name': 'Nebraska',
			'abbr': 'NE'
		},
		{
			'name': 'Nevada',
			'abbr': 'NV'
		},
		{
			'name': 'New Hampshire',
			'abbr': 'NH'
		},
		{
			'name': 'New Jersey',
			'abbr': 'NJ'
		},
		{
			'name': 'New Mexico',
			'abbr': 'NM'
		},
		{
			'name': 'New York',
			'abbr': 'NY'
		},
		{
			'name': 'North Carolina',
			'abbr': 'NC'
		},
		{
			'name': 'North Dakota',
			'abbr': 'ND'
		},
		{
			'name': 'Northern Mariana Islands',
			'abbr': 'MP'
		},
		{
			'name': 'Ohio',
			'abbr': 'OH'
		},
		{
			'name': 'Oklahoma',
			'abbr': 'OK'
		},
		{
			'name': 'Oregon',
			'abbr': 'OR'
		},
		{
			'name': 'Palau',
			'abbr': 'PW'
		},
		{
			'name': 'Pennsylvania',
			'abbr': 'PA'
		},
		{
			'name': 'Puerto Rico',
			'abbr': 'PR'
		},
		{
			'name': 'Rhode Island',
			'abbr': 'RI'
		},
		{
			'name': 'South Carolina',
			'abbr': 'SC'
		},
		{
			'name': 'South Dakota',
			'abbr': 'SD'
		},
		{
			'name': 'Tennessee',
			'abbr': 'TN'
		},
		{
			'name': 'Texas',
			'abbr': 'TX'
		},
		{
			'name': 'Utah',
			'abbr': 'UT'
		},
		{
			'name': 'Vermont',
			'abbr': 'VT'
		},
		{
			'name': 'Virgin Islands',
			'abbr': 'VI'
		},
		{
			'name': 'Virginia',
			'abbr': 'VA'
		},
		{
			'name': 'Washington',
			'abbr': 'WA'
		},
		{
			'name': 'West Virginia',
			'abbr': 'WV'
		},
		{
			'name': 'Wisconsin',
			'abbr': 'WI'
		},
		{
			'name': 'Wyoming',
			'abbr': 'WY'
		}
	];


	describeTypes: any[] = [
		{ name: '', code: '' },

		// { name: 'Feature', code: 'FT' },
		// { name: 'Activities', code: 'AC' },

		{ name: 'Master Bed ', code: 'MD' },
		{ name: 'Guest Bed 1', code: 'GD' },
		{ name: 'Guest Bed 2', code: 'GD2' },
		{ name: 'Guest Bed 3', code: 'GD3' },
		{ name: 'Guest Bed 4', code: 'GD4' },
		{ name: 'Guest Bed 5', code: 'GD5' },
		{ name: 'Guest Bed 6', code: 'GD6' },
		{ name: 'Guest Bed 7', code: 'GD7' },
		{ name: 'Guest Bed 8', code: 'GD8' },
		{ name: 'Guest Bed 9', code: 'GD9' },
		{ name: 'Master Bath ', code: 'MB' },
		{ name: 'Guest Bath 1', code: 'GB' },
		{ name: 'Guest Bath 2', code: 'GB2' },
		{ name: 'Guest Bath 3', code: 'GB3' },
		{ name: 'Guest Bath 4', code: 'GB4' },
		{ name: 'Guest Bath 5', code: 'GB5' },
		{ name: 'Guest Bath 6', code: 'GB6' },
		{ name: 'Guest Bath 7', code: 'GB7' },
		{ name: 'Guest Bath 8', code: 'GB8' },
		{ name: 'Guest Bath 9', code: 'GB9' },

		// Rooms
		{ name: 'Den', code: 'DE' },
		{ name: 'Dining', code: 'DN' },
		{ name: 'Entertainment', code: 'ET' },
		{ name: 'Family', code: 'FF' },
		{ name: 'Fitness', code: 'FR' }, 
		{ name: 'Kitchen', code: 'KN' },
		{ name: 'Laundry', code: 'LD' }, 
		{ name: 'Linen', code: 'LN' }, 
		{ name: 'Living', code: 'LV' },
		{ name: 'Mudroom', code: 'MUD' },
		{ name: 'Inside Schematic', code: 'IS' },
		{ name: 'Inside - other', code: 'OT' },

		// Amenities
		{ name: 'Bath + Body Amenities', code: 'BB' },
		{ name: 'Children Features', code: 'CD' },
		{ name: 'Cooling', code: 'CL' },
		{ name: 'Heating', code: 'HT' },
		{ name: 'Furnishings', code: 'FN' },


		// outside PICKUP HERE
		{ name: 'Balcony', code: 'BY' },
		{ name: 'Bbq', code: 'BQ' },
		{ name: 'Beach', code: 'BE' },
		{ name: 'Entrance', code: 'EN' },
		{ name: 'Health Club', code: 'HL' },
		{ name: 'Hot Tub', code: 'HO' },
		{ name: 'Parking', code: 'PK' },
		{ name: 'Pool', code: 'PO' },
		{ name: 'Restaurant', code: 'RS' },
		{ name: 'Shopping', code: 'SP' },
		{ name: 'View', code: 'VW' },
		{ name: 'Outside Schematic', code: 'ES' },
		{ name: 'Outside - other', code: 'OE' },










	];



	countries: any = [
		{ name: 'United States', dial: '+1', abbr: 'US' },
		{ name: 'Afghanistan', dial: '+93', abbr: 'AF' },
		{ name: 'Aland Islands', dial: '+358', abbr: 'AX' },
		{ name: 'Albania', dial: '+355', abbr: 'AL' },
		{ name: 'Algeria', dial: '+213', abbr: 'DZ' },
		{ name: 'AmericanSamoa', dial: '+1684', abbr: 'AS' },
		{ name: 'Andorra', dial: '+376', abbr: 'AD' },
		{ name: 'Angola', dial: '+244', abbr: 'AO' },
		{ name: 'Anguilla', dial: '+1264', abbr: 'AI' },
		{ name: 'Antarctica', dial: '+672', abbr: 'AQ' },
		{ name: 'Antigua and Barbuda', dial: '+1268', abbr: 'AG' },
		{ name: 'Argentina', dial: '+54', abbr: 'AR' },
		{ name: 'Armenia', dial: '+374', abbr: 'AM' },
		{ name: 'Aruba', dial: '+297', abbr: 'AW' },
		{ name: 'Australia', dial: '+61', abbr: 'AU' },
		{ name: 'Austria', dial: '+43', abbr: 'AT' },
		{ name: 'Azerbaijan', dial: '+994', abbr: 'AZ' },
		{ name: 'Bahamas', dial: '+1242', abbr: 'BS' },
		{ name: 'Bahrain', dial: '+973', abbr: 'BH' },
		{ name: 'Bangladesh', dial: '+880', abbr: 'BD' },
		{ name: 'Barbados', dial: '+1246', abbr: 'BB' },
		{ name: 'Belarus', dial: '+375', abbr: 'BY' },
		{ name: 'Belgium', dial: '+32', abbr: 'BE' },
		{ name: 'Belize', dial: '+501', abbr: 'BZ' },
		{ name: 'Benin', dial: '+229', abbr: 'BJ' },
		{ name: 'Bermuda', dial: '+1441', abbr: 'BM' },
		{ name: 'Bhutan', dial: '+975', abbr: 'BT' },
		{ name: 'Bolivia, Plurinational State of', dial: '+591', abbr: 'BO' },
		{ name: 'Bosnia and Herzegovina', dial: '+387', abbr: 'BA' },
		{ name: 'Botswana', dial: '+267', abbr: 'BW' },
		{ name: 'Brazil', dial: '+55', abbr: 'BR' },
		{ name: 'British Indian Ocean Territory', dial: '+246', abbr: 'IO' },
		{ name: 'Brunei Darussalam', dial: '+673', abbr: 'BN' },
		{ name: 'Bulgaria', dial: '+359', abbr: 'BG' },
		{ name: 'Burkina Faso', dial: '+226', abbr: 'BF' },
		{ name: 'Burundi', dial: '+257', abbr: 'BI' },
		{ name: 'Cambodia', dial: '+855', abbr: 'KH' },
		{ name: 'Cameroon', dial: '+237', abbr: 'CM' },
		{ name: 'Canada', dial: '+1', abbr: 'CA' },
		{ name: 'Cape Verde', dial: '+238', abbr: 'CV' },
		{ name: 'Cayman Islands', dial: '+1345', abbr: 'KY' },
		{ name: 'Central African Republic', dial: '+236', abbr: 'CF' },
		{ name: 'Chad', dial: '+235', abbr: 'TD' },
		{ name: 'Chile', dial: '+56', abbr: 'CL' },
		{ name: 'China', dial: '+86', abbr: 'CN' },
		{ name: 'Christmas Island', dial: '+61', abbr: 'CX' },
		{ name: 'Cocos (Keeling) Islands', dial: '+61', abbr: 'CC' },
		{ name: 'Colombia', dial: '+57', abbr: 'CO' },
		{ name: 'Comoros', dial: '+269', abbr: 'KM' },
		{ name: 'Congo', dial: '+242', abbr: 'CG' },
		{ name: 'Congo, The Democratic Republic of the Congo', dial: '+243', abbr: 'CD' },
		{ name: 'Cook Islands', dial: '+682', abbr: 'CK' },
		{ name: 'Costa Rica', dial: '+506', abbr: 'CR' },
		{ name: 'Cote dIvoire', dial: '+225', abbr: 'CI' },
		{ name: 'Croatia', dial: '+385', abbr: 'HR' },
		{ name: 'Cuba', dial: '+53', abbr: 'CU' },
		{ name: 'Cyprus', dial: '+357', abbr: 'CY' },
		{ name: 'Czech Republic', dial: '+420', abbr: 'CZ' },
		{ name: 'Denmark', dial: '+45', abbr: 'DK' },
		{ name: 'Djibouti', dial: '+253', abbr: 'DJ' },
		{ name: 'Dominica', dial: '+1767', abbr: 'DM' },
		{ name: 'Dominican Republic', dial: '+1849', abbr: 'DO' },
		{ name: 'Ecuador', dial: '+593', abbr: 'EC' },
		{ name: 'Egypt', dial: '+20', abbr: 'EG' },
		{ name: 'El Salvador', dial: '+503', abbr: 'SV' },
		{ name: 'Equatorial Guinea', dial: '+240', abbr: 'GQ' },
		{ name: 'Eritrea', dial: '+291', abbr: 'ER' },
		{ name: 'Estonia', dial: '+372', abbr: 'EE' },
		{ name: 'Ethiopia', dial: '+251', abbr: 'ET' },
		{ name: 'Falkland Islands (Malvinas)', dial: '+500', abbr: 'FK' },
		{ name: 'Faroe Islands', dial: '+298', abbr: 'FO' },
		{ name: 'Fiji', dial: '+679', abbr: 'FJ' },
		{ name: 'Finland', dial: '+358', abbr: 'FI' },
		{ name: 'France', dial: '+33', abbr: 'FR' },
		{ name: 'French Guiana', dial: '+594', abbr: 'GF' },
		{ name: 'French Polynesia', dial: '+689', abbr: 'PF' },
		{ name: 'Gabon', dial: '+241', abbr: 'GA' },
		{ name: 'Gambia', dial: '+220', abbr: 'GM' },
		{ name: 'Georgia', dial: '+995', abbr: 'GE' },
		{ name: 'Germany', dial: '+49', abbr: 'DE' },
		{ name: 'Ghana', dial: '+233', abbr: 'GH' },
		{ name: 'Gibraltar', dial: '+350', abbr: 'GI' },
		{ name: 'Greece', dial: '+30', abbr: 'GR' },
		{ name: 'Greenland', dial: '+299', abbr: 'GL' },
		{ name: 'Grenada', dial: '+1473', abbr: 'GD' },
		{ name: 'Guadeloupe', dial: '+590', abbr: 'GP' },
		{ name: 'Guam', dial: '+1671', abbr: 'GU' },
		{ name: 'Guatemala', dial: '+502', abbr: 'GT' },
		{ name: 'Guernsey', dial: '+44', abbr: 'GG' },
		{ name: 'Guinea', dial: '+224', abbr: 'GN' },
		{ name: 'Guinea-Bissau', dial: '+245', abbr: 'GW' },
		{ name: 'Guyana', dial: '+595', abbr: 'GY' },
		{ name: 'Haiti', dial: '+509', abbr: 'HT' },
		{ name: 'Holy See (Vatican City State)', dial: '+379', abbr: 'VA' },
		{ name: 'Honduras', dial: '+504', abbr: 'HN' },
		{ name: 'Hong Kong', dial: '+852', abbr: 'HK' },
		{ name: 'Hungary', dial: '+36', abbr: 'HU' },
		{ name: 'Iceland', dial: '+354', abbr: 'IS' },
		{ name: 'India', dial: '+91', abbr: 'IN' },
		{ name: 'Indonesia', dial: '+62', abbr: 'ID' },
		{ name: 'Iran, Islamic Republic of Persian Gulf', dial: '+98', abbr: 'IR' },
		{ name: 'Iraq', dial: '+964', abbr: 'IQ' },
		{ name: 'Ireland', dial: '+353', abbr: 'IE' },
		{ name: 'Isle of Man', dial: '+44', abbr: 'IM' },
		{ name: 'Israel', dial: '+972', abbr: 'IL' },
		{ name: 'Italy', dial: '+39', abbr: 'IT' },
		{ name: 'Jamaica', dial: '+1876', abbr: 'JM' },
		{ name: 'Japan', dial: '+81', abbr: 'JP' },
		{ name: 'Jersey', dial: '+44', abbr: 'JE' },
		{ name: 'Jordan', dial: '+962', abbr: 'JO' },
		{ name: 'Kazakhstan', dial: '+77', abbr: 'KZ' },
		{ name: 'Kenya', dial: '+254', abbr: 'KE' },
		{ name: 'Kiribati', dial: '+686', abbr: 'KI' },
		{ name: 'Korea, Democratic Peoples Republic of Korea', dial: '+850', abbr: 'KP' },
		{ name: 'Korea, Republic of South Korea', dial: '+82', abbr: 'KR' },
		{ name: 'Kuwait', dial: '+965', abbr: 'KW' },
		{ name: 'Kyrgyzstan', dial: '+996', abbr: 'KG' },
		{ name: 'Laos', dial: '+856', abbr: 'LA' },
		{ name: 'Latvia', dial: '+371', abbr: 'LV' },
		{ name: 'Lebanon', dial: '+961', abbr: 'LB' },
		{ name: 'Lesotho', dial: '+266', abbr: 'LS' },
		{ name: 'Liberia', dial: '+231', abbr: 'LR' },
		{ name: 'Libyan Arab Jamahiriya', dial: '+218', abbr: 'LY' },
		{ name: 'Liechtenstein', dial: '+423', abbr: 'LI' },
		{ name: 'Lithuania', dial: '+370', abbr: 'LT' },
		{ name: 'Luxembourg', dial: '+352', abbr: 'LU' },
		{ name: 'Macao', dial: '+853', abbr: 'MO' },
		{ name: 'Macedonia', dial: '+389', abbr: 'MK' },
		{ name: 'Madagascar', dial: '+261', abbr: 'MG' },
		{ name: 'Malawi', dial: '+265', abbr: 'MW' },
		{ name: 'Malaysia', dial: '+60', abbr: 'MY' },
		{ name: 'Maldives', dial: '+960', abbr: 'MV' },
		{ name: 'Mali', dial: '+223', abbr: 'ML' },
		{ name: 'Malta', dial: '+356', abbr: 'MT' },
		{ name: 'Marshall Islands', dial: '+692', abbr: 'MH' },
		{ name: 'Martinique', dial: '+596', abbr: 'MQ' },
		{ name: 'Mauritania', dial: '+222', abbr: 'MR' },
		{ name: 'Mauritius', dial: '+230', abbr: 'MU' },
		{ name: 'Mayotte', dial: '+262', abbr: 'YT' },
		{ name: 'Mexico', dial: '+52', abbr: 'MX' },
		{ name: 'Micronesia, Federated States of Micronesia', dial: '+691', abbr: 'FM' },
		{ name: 'Moldova', dial: '+373', abbr: 'MD' },
		{ name: 'Monaco', dial: '+377', abbr: 'MC' },
		{ name: 'Mongolia', dial: '+976', abbr: 'MN' },
		{ name: 'Montenegro', dial: '+382', abbr: 'ME' },
		{ name: 'Montserrat', dial: '+1664', abbr: 'MS' },
		{ name: 'Morocco', dial: '+212', abbr: 'MA' },
		{ name: 'Mozambique', dial: '+258', abbr: 'MZ' },
		{ name: 'Myanmar', dial: '+95', abbr: 'MM' },
		{ name: 'Namibia', dial: '+264', abbr: 'NA' },
		{ name: 'Nauru', dial: '+674', abbr: 'NR' },
		{ name: 'Nepal', dial: '+977', abbr: 'NP' },
		{ name: 'Netherlands', dial: '+31', abbr: 'NL' },
		{ name: 'Netherlands Antilles', dial: '+599', abbr: 'AN' },
		{ name: 'New Caledonia', dial: '+687', abbr: 'NC' },
		{ name: 'New Zealand', dial: '+64', abbr: 'NZ' },
		{ name: 'Nicaragua', dial: '+505', abbr: 'NI' },
		{ name: 'Niger', dial: '+227', abbr: 'NE' },
		{ name: 'Nigeria', dial: '+234', abbr: 'NG' },
		{ name: 'Niue', dial: '+683', abbr: 'NU' },
		{ name: 'Norfolk Island', dial: '+672', abbr: 'NF' },
		{ name: 'Northern Mariana Islands', dial: '+1670', abbr: 'MP' },
		{ name: 'Norway', dial: '+47', abbr: 'NO' },
		{ name: 'Oman', dial: '+968', abbr: 'OM' },
		{ name: 'Pakistan', dial: '+92', abbr: 'PK' },
		{ name: 'Palau', dial: '+680', abbr: 'PW' },
		{ name: 'Palestinian Territory, Occupied', dial: '+970', abbr: 'PS' },
		{ name: 'Panama', dial: '+507', abbr: 'PA' },
		{ name: 'Papua New Guinea', dial: '+675', abbr: 'PG' },
		{ name: 'Paraguay', dial: '+595', abbr: 'PY' },
		{ name: 'Peru', dial: '+51', abbr: 'PE' },
		{ name: 'Philippines', dial: '+63', abbr: 'PH' },
		{ name: 'Pitcairn', dial: '+872', abbr: 'PN' },
		{ name: 'Poland', dial: '+48', abbr: 'PL' },
		{ name: 'Portugal', dial: '+351', abbr: 'PT' },
		{ name: 'Puerto Rico', dial: '+1939', abbr: 'PR' },
		{ name: 'Qatar', dial: '+974', abbr: 'QA' },
		{ name: 'Romania', dial: '+40', abbr: 'RO' },
		{ name: 'Russia', dial: '+7', abbr: 'RU' },
		{ name: 'Rwanda', dial: '+250', abbr: 'RW' },
		{ name: 'Reunion', dial: '+262', abbr: 'RE' },
		{ name: 'Saint Barthelemy', dial: '+590', abbr: 'BL' },
		{ name: 'Saint Helena, Ascension and Tristan Da Cunha', dial: '+290', abbr: 'SH' },
		{ name: 'Saint Kitts and Nevis', dial: '+1869', abbr: 'KN' },
		{ name: 'Saint Lucia', dial: '+1758', abbr: 'LC' },
		{ name: 'Saint Martin', dial: '+590', abbr: 'MF' },
		{ name: 'Saint Pierre and Miquelon', dial: '+508', abbr: 'PM' },
		{ name: 'Saint Vincent and the Grenadines', dial: '+1784', abbr: 'VC' },
		{ name: 'Samoa', dial: '+685', abbr: 'WS' },
		{ name: 'San Marino', dial: '+378', abbr: 'SM' },
		{ name: 'Sao Tome and Principe', dial: '+239', abbr: 'ST' },
		{ name: 'Saudi Arabia', dial: '+966', abbr: 'SA' },
		{ name: 'Senegal', dial: '+221', abbr: 'SN' },
		{ name: 'Serbia', dial: '+381', abbr: 'RS' },
		{ name: 'Seychelles', dial: '+248', abbr: 'SC' },
		{ name: 'Sierra Leone', dial: '+232', abbr: 'SL' },
		{ name: 'Singapore', dial: '+65', abbr: 'SG' },
		{ name: 'Slovakia', dial: '+421', abbr: 'SK' },
		{ name: 'Slovenia', dial: '+386', abbr: 'SI' },
		{ name: 'Solomon Islands', dial: '+677', abbr: 'SB' },
		{ name: 'Somalia', dial: '+252', abbr: 'SO' },
		{ name: 'South Africa', dial: '+27', abbr: 'ZA' },
		{ name: 'South Sudan', dial: '+211', abbr: 'SS' },
		{ name: 'South Georgia and the South Sandwich Islands', dial: '+500', abbr: 'GS' },
		{ name: 'Spain', dial: '+34', abbr: 'ES' },
		{ name: 'Sri Lanka', dial: '+94', abbr: 'LK' },
		{ name: 'Sudan', dial: '+249', abbr: 'SD' },
		{ name: 'Suriname', dial: '+597', abbr: 'SR' },
		{ name: 'Svalbard and Jan Mayen', dial: '+47', abbr: 'SJ' },
		{ name: 'Swaziland', dial: '+268', abbr: 'SZ' },
		{ name: 'Sweden', dial: '+46', abbr: 'SE' },
		{ name: 'Switzerland', dial: '+41', abbr: 'CH' },
		{ name: 'Syrian Arab Republic', dial: '+963', abbr: 'SY' },
		{ name: 'Taiwan', dial: '+886', abbr: 'TW' },
		{ name: 'Tajikistan', dial: '+992', abbr: 'TJ' },
		{ name: 'Tanzania, United Republic of Tanzania', dial: '+255', abbr: 'TZ' },
		{ name: 'Thailand', dial: '+66', abbr: 'TH' },
		{ name: 'Timor-Leste', dial: '+670', abbr: 'TL' },
		{ name: 'Togo', dial: '+228', abbr: 'TG' },
		{ name: 'Tokelau', dial: '+690', abbr: 'TK' },
		{ name: 'Tonga', dial: '+676', abbr: 'TO' },
		{ name: 'Trinidad and Tobago', dial: '+1868', abbr: 'TT' },
		{ name: 'Tunisia', dial: '+216', abbr: 'TN' },
		{ name: 'Turkey', dial: '+90', abbr: 'TR' },
		{ name: 'Turkmenistan', dial: '+993', abbr: 'TM' },
		{ name: 'Turks and Caicos Islands', dial: '+1649', abbr: 'TC' },
		{ name: 'Tuvalu', dial: '+688', abbr: 'TV' },
		{ name: 'Uganda', dial: '+256', abbr: 'UG' },
		{ name: 'Ukraine', dial: '+380', abbr: 'UA' },
		{ name: 'United Arab Emirates', dial: '+971', abbr: 'AE' },
		{ name: 'United Kingdom', dial: '+44', abbr: 'GB' },		
		{ name: 'Uruguay', dial: '+598', abbr: 'UY' },
		{ name: 'Uzbekistan', dial: '+998', abbr: 'UZ' },
		{ name: 'Vanuatu', dial: '+678', abbr: 'VU' },
		{ name: 'Venezuela, Bolivarian Republic of Venezuela', dial: '+58', abbr: 'VE' },
		{ name: 'Vietnam', dial: '+84', abbr: 'VN' },
		{ name: 'Virgin Islands, British', dial: '+1284', abbr: 'VG' },
		{ name: 'Virgin Islands, U.S.', dial: '+1340', abbr: 'VI' },
		{ name: 'Wallis and Futuna', dial: '+681', abbr: 'WF' },
		{ name: 'Yemen', dial: '+967', abbr: 'YE' },
		{ name: 'Zambia', dial: '+260', abbr: 'ZM' },
		{ name: 'Zimbabwe', dial: '+263', abbr: 'ZW' }
	];

	surveyStages: any = [
		{ value: '1', name: 'DayOfArrival' },
		{ value: '2', name: 'DayAfterArrival' },
		{ value: '3', name: 'DayBeforeDeparture' },
		{ value: '4', name: 'DayOfDeparture' },
		{ value: '5', name: 'DayAfterDeparture' },
	];

	referralSourceContexts: any[] = [
		{ label: 'Website', value: 1 },
		{ label: 'Hold', value: 2 },
		{ label: 'Quote', value: 3 },
		{ label: 'Manual', value: 4 },
	];

	getChannelPictureURL (value: any) {
		if (value) {
			return this.refSrcImages.find(function(item) { return item.value == value })?.imgurl;
		}
		return 'assets/img/header-logo.png'
	};

	getReferralSourceContextLabel (value: any) {
		return this.referralSourceContexts.find(function(item) { return item.value == value })?.label ?? '';
	};
}
